import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/third-place.png")